import React, { ReactNode } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useStyles } from './styles'
import { IconButton } from '@mui/material'
import { Loading } from '../UI'

interface DataGridRowTreeViewProps {
  details?: JSX.Element | JSX.Element[]
  id?: number
  onClick: (id: number | undefined) => void
  loading?: boolean
  menuContext?: JSX.Element | JSX.Element[]
  expanded?: boolean
  defaultExpanded?: boolean
  children?: ReactNode
}

export const DataGridRowTreeView: React.FC<DataGridRowTreeViewProps> = ({
  children,
  details,
  id,
  onClick,
  loading,
  expanded: controlledExpanded,
  defaultExpanded = false
}) => {
  const classes = useStyles()
  const [internalExpanded, setInternalExpanded] =
    React.useState(defaultExpanded)

  // Si expanded está definido, usar modo controlado, sino usar modo no controlado
  const isControlled = controlledExpanded !== undefined
  const expanded = isControlled ? controlledExpanded : internalExpanded

  const handleToggle = () => {
    const newExpandedState = !expanded

    if (!isControlled) {
      setInternalExpanded(newExpandedState)
    }

    // Llamar onClick siempre, pasando el nuevo estado
    onClick(id)
  }

  return (
    <div className={classes.root}>
      <Accordion expanded={expanded}>
        <AccordionSummary
          id='panelSummary'
          classes={{
            expandIconWrapper: classes.expandIcon,
            expanded: classes.expanded,
            content: classes.content
          }}
          expandIcon={
            <IconButton
              color='primary'
              aria-label='expand'
              style={{ width: '10px', minWidth: '10px' }}
            >
              <ExpandMoreIcon />
            </IconButton>
          }
          className={classes.summary}
          style={{ cursor: 'pointer' }}
          onClick={handleToggle}
        >
          {children}
        </AccordionSummary>
        {loading && <Loading />}

        {!loading && (
          <AccordionDetails id='panelSummary2' style={{ display: 'flow-root' }}>
            {details}
          </AccordionDetails>
        )}
      </Accordion>
    </div>
  )
}
